import router from "@common/router";

export class RouteHelper
{
    static getProjectUrl(workspaceId: number, tchProjectId: number, projectId: string): string
    {
        const path = `/alternative/dashboard/${workspaceId}/${tchProjectId}/${projectId}`;
        const resolvedPath = router.resolve({ path }).href;
        return `${window.location.origin}${resolvedPath}`;
    }

    static getProjectPlanUrl(workspaceId: number, tchProjectId: number, projectId: string): string
    {
        const path = `/q/project/summary/${workspaceId}/${tchProjectId}/${projectId}`;
        const resolvedPath = router.resolve({ path }).href;
        return `${window.location.origin}${resolvedPath}`;
    }

    static getProjectPnlUrl(workspaceId: number, tchProjectId: number, projectId: string): string
    {
        const path = `/q/project/pnl/${workspaceId}/${tchProjectId}/${projectId}`;
        const resolvedPath = router.resolve({ path }).href;
        return `${window.location.origin}${resolvedPath}`;
    }
}